import { PageController } from '../apps/page-state';
import store from './store';

export const pageController = new PageController(store);
